import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromProfileActions from './store-configuration.actions';
import * as fromReducer from '../store.reducer';
import {
  IStoreProfileStateError,
  IStoreProfileStateSuccess,
} from '@boxx/store-core';
import * as fromSelectors from './store-configuration.selectors';
import { IStoreBase } from '@boxx/core';
import { IUpdateProfileStorePayload, StoreProfileModel } from '../../models/Store.model';
import { IUpdateProfilePayload } from '@boxx/profile-core/lib/repositories/IProfile.repository';

@Injectable()
export class StoreConfigurationStore
  implements
    IStoreBase<
      StoreProfileModel,
      IStoreProfileStateSuccess,
      IStoreProfileStateError
    >
{
  constructor(public store: Store<fromReducer.IStoreState>) {}
  fetch: (params?: any) => void;

  get loading$() {
    return this.store.select(fromSelectors.getProfileIsloading);
  }
  get data$() {
    return this.store.select(fromSelectors.getProfileData);
  }
  get fetched$() {
    return this.store.select(fromSelectors.getProfileHasBeenFetched);
  }
  get error$() {
    return this.store.select(fromSelectors.getProfileError);
  }
  get success$() {
    return this.store.select(fromSelectors.getProfileSuccess);
  }

  loadProfile = () =>
    this.store.dispatch(fromProfileActions.loadProfileBeginAction());

  updateProfile = (payload: IUpdateProfileStorePayload) =>
    this.store.dispatch(
      fromProfileActions.updateProfileBeginAction({ payload })
    );

  uploadImageProfile = (payload: string) =>
    this.store.dispatch(
      fromProfileActions.uploadImageProfileBeginAction( {payload} )
    );

    
  deleteImageProfile = (id: number) =>
    this.store.dispatch(
      fromProfileActions.deleteImageProfileBeginAction({ id })
    );

}
